import { getMessages } from '../../../../../store/constants';

export const FIELDS_COLUMNS = getMessages().getText('list_view.fields_columns');
